import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MasterHelper } from './../../core/utilities/master-helper';
import { PublishReportResponse } from './../../core/models/regulation/publish-regulation-model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { RegulationService } from 'src/app/core/services/regulation';
import { ThemeGetModel } from 'src/app/core/models/user-management/get-theme-details-model';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { ToastViewModel } from 'src/app/core/models/view-model';



@Component({
  selector: 'app-publish-report',
  templateUrl: './publish-report.component.html',
  styleUrls: ['./publish-report.component.scss']
})
export class PublishReportComponent implements OnInit, AfterViewInit {

  publishReport!: PublishReportResponse;
  @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;
  loading: boolean = false;
  imageSrc: string | null = null;
  themeDetails!: ThemeGetModel;
  base64String = "";
  contentCopy!: HTMLElement;
  toastModel: ToastViewModel;
  isToastShow = false;


  constructor(private regulationService: RegulationService, private http: HttpClient, private userManagement: UserManagementService, private el: ElementRef) {
    this.toastModel = new ToastViewModel();
    const persistFilter = JSON.parse(MasterHelper.fetchFromBrowser('_prod') as string) as PublishReportResponse;
    if (persistFilter) {
      this.publishReport = persistFilter;
      this.publishReport.reportData.forEach(data => {
        data.regulations.forEach(data1 => {
          data1.description = data1.description.replace(/\n/g, '<br>');
        });
      });
    }
  }

  ngOnInit(): void {
    this.fetchUserTheme();
  }
  ngAfterViewInit() {
    const contentToCopy = this.el.nativeElement.querySelector('#contentToCopy');
    if (contentToCopy) {
      this.contentCopy = contentToCopy;
    } else {
      console.error("Element with ID 'contentToCopy' not found.");
    }
  }
  exportAsPDF() {
    this.loading = true;
    const htmlContent = this.pdfContent.nativeElement.innerHTML;
    this.regulationService.DownloadtPublishReport(htmlContent).subscribe(
      (response: any) => {
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(response);
        a.href = fileURL;
        a.download = `PublishReport.pdf`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
        this.loading = false;
      });
  }

  copyToClipboard() {
    if (this.imageSrc !== null) {
      fetch(this.imageSrc)
        .then((response) => response.blob())
        .then((blob) => {
          const clipboardItems = [
            new ClipboardItem({
              'text/html': new Blob([this.contentCopy.outerHTML], { type: 'text/html' }),
              'image/png': blob,
            }),
          ];
          navigator.clipboard.write(clipboardItems).then(() => {
            this.toastModel.Title = 'Success';
            this.toastModel.Type = 'success';
            this.toastModel.Message = 'Publish Report is copied to Clipboard.';
            this.isToastShow = true;
            setTimeout(() => {
              this.isToastShow = false;
            }, 2000);
          }).catch((error) => {
            this.toastModel.Title = 'Warning';
            this.toastModel.Type = 'warning';
            this.toastModel.Message = 'Something went wrong.';
            this.isToastShow = true;
            setTimeout(() => {
              this.isToastShow = false;
            }, 2000);
          });
        })
        .catch((error) => {
          this.toastModel.Title = 'Warning';
          this.toastModel.Type = 'warning';
          this.toastModel.Message = 'Something went wrong.';
          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 2000);
        });
    }
  }

  fetchUserTheme(): void {
    this.imageSrc = localStorage.getItem('imageSrc');
    if (this.imageSrc == null) {
      this.userManagement.getThemeDetails().subscribe((res: ThemeGetModel) => {
        this.themeDetails = res;
        this.imageSrc = `data:image/png;base64,${this.themeDetails.image}`;
      });
    }
  }
}
